import { Config } from '@comall-backend-builder/core/lib/parser';

export let config: Config = {
    entities: {
        categoryList: {
            apiPath: '/display_category',
            properties: {
                id: {
                    type: 'number.integer',
                    displayName: 'id',
                },
                name: {
                    type: 'string',
                    displayName: '名称',
                },
                sequence: {
                    type: 'number.integer',
                    displayName: '排序',
                },
                level: {
                    type: 'number.integer',
                    displayName: '分类级别',
                },
                refresh: {
                    type: 'string',
                    displayName: '是否刷新分类',
                },
                status: {
                    type: 'string.options.select',
                    displayName: '分类状态',
                    options: [
                        {
                            id: 'ENABLE',
                            name: '启用',
                        },
                        {
                            id: 'DISABLE',
                            name: '禁用',
                        },
                    ],
                },
                imgType: {
                    type: 'string.options.select',
                    displayName: '图片样式',
                    options: [
                        {
                            id: '0',
                            name: '一行一张图',
                        },
                        {
                            id: '1',
                            name: '一行两张图',
                        },
                        {
                            id: '2',
                            name: '一行三张图',
                        },
                    ],
                },
                imgApp: {
                    type: 'string.image.text',
                    displayName: '图片',
                },
            },
            filters: {
                displayCategoryId: {
                    type: 'string',
                },
            },
        },
        categoryTree: {
            apiPath: '/loader/category-tree',
        },
        // 添加菜单
        categoryMenu: {
            apiPath: '/loader/category-base-info',
            properties: {
                name: {
                    type: 'string',
                    displayName: '导航名称',
                    rules: [
                        {
                            required: true,
                        },
                    ],
                },
                sequence: {
                    type: 'number.integer',
                    displayName: '排序值',
                },
            },
        },
        categoryAddBaseInfo: {
            apiPath: '/loader/category-base-three-info',
            properties: {
                parentId: {
                    type: 'string.options.select',
                    displayName: '所属展示分类',
                },
                name: {
                    type: 'string',
                    displayName: '展示图名称',
                    rules: [
                        {
                            required: true,
                        },
                    ],
                },
                specialType: {
                    type: 'string.options.select',
                    displayName: '特殊类型',
                    options: [
                        {
                            id: 'STORE',
                            name: '门店专属类型',
                        },
                        {
                            id: 'NORMAL',
                            name: '普通类型',
                        },
                    ],
                    rules: [
                        {
                            required: true,
                        },
                    ],
                },
                imgType: {
                    type: 'string.options.select',
                    displayName: '图片样式',
                    options: [
                        {
                            id: '0',
                            name: '一行一张图',
                        },
                        {
                            id: '1',
                            name: '一行两张图',
                        },
                        {
                            id: '2',
                            name: '一行三张图',
                        },
                    ],
                    rules: [
                        {
                            required: true,
                        },
                    ],
                },
                sequence: {
                    type: 'number.integer',
                    displayName: '排序值',
                },
                imgApp: {
                    type: 'string.image.picker',
                    displayName: '移动端图片',
                },
            },
        },

        categoryClassificationInfo: {
            apiPath: '/loader/category-base-info',
            properties: {
                parentId: {
                    type: 'string.options.select',
                    displayName: '所属展示分类',
                },
                name: {
                    type: 'string',
                    displayName: '分类名称',
                    rules: [
                        {
                            required: true,
                        },
                    ],
                },
                imgType: {
                    type: 'string.options.select',
                    displayName: '图片样式',
                    options: [
                        {
                            id: '0',
                            name: '一行一张图',
                        },
                        {
                            id: '1',
                            name: '一行两张图',
                        },
                        {
                            id: '2',
                            name: '一行三张图',
                        },
                    ],
                    rules: [
                        {
                            required: true,
                        },
                    ],
                },
                sequence: {
                    type: 'number.integer',
                    displayName: '排序值',
                },
            },
        },

        categoryEditBaseInfo: {
            apiPath: '/loader/category-base-info',
            properties: {
                path: {
                    type: 'string',
                    displayName: '所属展示分类',
                },
                name: {
                    type: 'string',
                    displayName: '分类名称',
                    rules: [
                        {
                            required: true,
                        },
                    ],
                },
                specialType: {
                    type: 'string.options.select',
                    displayName: '特殊类型',
                    options: [
                        {
                            id: 'STORE',
                            name: '门店专属类型',
                        },
                        {
                            id: 'NORMAL',
                            name: '普通类型',
                        },
                    ],
                    rules: [
                        {
                            required: true,
                        },
                    ],
                },
                imgType: {
                    type: 'string.options.select',
                    displayName: '图片样式',
                    options: [
                        {
                            id: '0',
                            name: '一行一张图',
                        },
                        {
                            id: '1',
                            name: '一行两张图',
                        },
                        {
                            id: '2',
                            name: '一行三张图',
                        },
                    ],
                    rules: [
                        {
                            required: true,
                        },
                    ],
                },
                sequence: {
                    type: 'number.integer',
                    displayName: '排序值',
                },
                imgAppUrl: {
                    type: 'string.image.picker.pzg',
                    displayName: '移动端图片',
                },
            },
        },
        categoryUnionProduct: {
            apiPath: '/loader/category-union-product',
            properties: {
                attrName: {
                    type: 'string',
                    displayName: '关联属性',
                },
                attrValues: {
                    type: 'string',
                    displayName: '关联属性值',
                },
                productName: {
                    type: 'string',
                    displayName: '商品名称',
                },
                skuCode: {
                    type: 'string',
                    displayName: '商品sku',
                },
            },
            filters: {
                unionType: {
                    type: 'string.options.select',
                    displayName: '关联商品',
                    options: [
                        {
                            id: 'ATTR',
                            name: '通过属性关联',
                        },
                        {
                            id: 'PRODUCT',
                            name: '直接关联商品',
                        },
                    ],
                },
            },
        },
        categoryUnionProductType: {
            apiPath: '/loader/category-union-product-type',
            properties: {
                unionType: {
                    type: 'string.options.select',
                    displayName: '关联类型',
                    controlConfig: { placeholder: '请选择关联类型' },
                    options: [
                        {
                            id: 'ATTR',
                            name: '通过属性关联',
                        },
                        {
                            id: 'PRODUCT',
                            name: '直接关联商品',
                        },
                    ],
                    rules: [
                        {
                            required: true,
                        },
                    ],
                },
            },
        },
        categoryFilterAttr: {
            apiPath: '/loader/category-filter-attr',
            properties: {
                attrName: {
                    type: 'string',
                    displayName: '关联属性',
                },
                attrOptionValue: {
                    type: 'string',
                    displayName: '关联属性值',
                },
                sequence: {
                    type: 'number.integer',
                    displayName: '排序',
                },
            },
        },
    },
    components: {
        categoryMainView: {
            component: 'Card',
            content: {
                component: 'FlexLayout',
                direction: 'vertical',
                items: [
                    {
                        component: 'categoryCombineView',
                    },
                ],
            },
        },
        categoryCombineView: {
            entities: [
                {
                    name: 'categoryList',
                    entityName: 'categoryList',
                },
                {
                    name: 'categoryTree',
                    entityName: 'categoryTree',
                    loaderType: 'get',
                },
            ],
            component: 'CategoryCombineList',
        },

        categoryMenuView: {
            component: 'Card',
            content: {
                component: 'categoryMenuForm',
            },
        },

        categoryAddView: {
            component: 'Card',
            content: {
                component: 'categoryAddBaseInfoForm',
            },
        },

        categoryClassificationAdd: {
            component: 'Card',
            content: {
                component: 'categoryAddClassification',
            },
        },

        categoryMenuForm: {
            component: 'CreateForm',
            entity: 'categoryMenu',
            labelCol: 8,
            submit: true,
            submitSuccessBehavior: {
                route: 'goBack',
            },
            style: {
                width: '400px',
                marginTop: 32,
            },
            footer: {
                style: {
                    textAlign: 'right',
                    marginTop: 32,
                },
                items: [
                    {
                        text: '返回',
                        htmlType: 'button',
                        type: 'default',
                        route: 'goBack',
                        style: { marginLeft: 16, marginRight: 80 },
                    },
                ],
            },
            fields: [
                {
                    property: 'name',
                },
                {
                    property: 'sequence',
                    controlConfig: {
                        min: 0,
                        formatter: (value: number) => {
                            return parseInt(value.toString()) || 0;
                        },
                        parser: (value: number) => {
                            return parseInt(value.toString()) || 0;
                        },
                    },
                },
            ],
        },

        // 新增分类form
        categoryAddClassification: {
            component: 'CreateForm',
            entity: 'categoryClassificationInfo',
            labelCol: 8,
            submit: true,
            submitSuccessBehavior: {
                route: 'goBack',
            },
            style: {
                width: '400px',
                marginTop: 32,
            },
            footer: {
                style: {
                    textAlign: 'right',
                    marginTop: 32,
                },
                items: [
                    {
                        text: '返回',
                        htmlType: 'button',
                        type: 'default',
                        route: 'goBack',
                        style: { marginLeft: 16, marginRight: 80 },
                    },
                ],
            },
            fields: [
                {
                    property: 'name',
                },
                {
                    property: 'imgType',
                },
                {
                    property: 'sequence',
                    controlConfig: {
                        min: 0,
                        formatter: (value: number) => {
                            return parseInt(value.toString()) || 0;
                        },
                        parser: (value: number) => {
                            return parseInt(value.toString()) || 0;
                        },
                    },
                },
            ],
        },

        categoryEditView: {
            component: 'Card',
            content: {
                component: 'FlexLayout',
                direction: 'vertical',
                items: [
                    {
                        component: 'CategoryEditTabs',
                    },
                ],
            },
        },

        // 修改菜单
        categoryEditMenuCom: {
            component: 'ModifyForm',
            entity: 'categoryMenu',
            labelCol: 8,
            loaderType: 'get',
            submit: {
                text: '保存',
            },
            submitSuccessBehavior: {
                route: 'goBack',
            },
            style: {
                width: '400px',
                marginTop: 32,
            },

            footer: {
                style: {
                    textAlign: 'right',
                    marginTop: 32,
                },
                items: [
                    {
                        text: '返回',
                        htmlType: 'button',
                        type: 'default',
                        route: 'goBack',
                        style: { marginLeft: 16, marginRight: 80 },
                    },
                ],
            },
            fields: [
                {
                    property: 'name',
                },
                {
                    property: 'sequence',
                    controlConfig: {
                        min: 0,
                        formatter: (value: number) => {
                            return parseInt(value.toString()) || 0;
                        },
                        parser: (value: number) => {
                            return parseInt(value.toString()) || 0;
                        },
                    },
                },
            ],
        },

        categoryEditMenu: {
            component: 'Card',
            content: {
                component: 'categoryEditMenuCom',
            },
        },

        categoryAddBaseInfoForm: {
            component: 'ModifyForm',
            entity: 'categoryAddBaseInfo',
            labelCol: 8,
            loaderType: 'get',
            submit: true,
            submitSuccessBehavior: {
                route: 'goBack',
            },
            style: {
                width: '400px',
                marginTop: 32,
            },
            footer: {
                style: {
                    textAlign: 'right',
                    marginTop: 32,
                },
                items: [
                    {
                        text: '返回',
                        htmlType: 'button',
                        type: 'default',
                        route: 'goBack',
                        style: { marginLeft: 16, marginRight: 80 },
                    },
                ],
            },
            fields: [
                {
                    property: 'name',
                },
                {
                    property: 'imgType',
                    modifiable: false,
                },
                {
                    property: 'sequence',
                    controlConfig: {
                        min: 0,
                        formatter: (value: number) => {
                            return parseInt(value.toString()) || 0;
                        },
                        parser: (value: number) => {
                            return parseInt(value.toString()) || 0;
                        },
                    },
                },
                {
                    property: 'imgApp',
                    width: 200,
                    rules: [{ required: false }],
                    controlConfig: {
                        maxCount: 1,
                        multiple: false,
                        fileName: 'fileName',
                        uploadUrl: `${ENV.API_ROOT}/images`,
                        mode: 'picture-card',
                    },
                    displayConfig: {
                        style: {
                            width: 50,
                        },
                    },
                },
            ],
        },

        // 修改展示分类(二层菜单)
        categorySecondBaseInfoForm: {
            component: 'ModifyForm',
            entity: 'categoryEditBaseInfo',
            labelCol: 8,
            loaderType: 'get',
            submit: {
                text: '保存',
            },
            submitSuccessBehavior: {
                route: 'goBack',
            },
            style: {
                width: '400px',
                marginTop: 32,
            },

            footer: {
                style: {
                    textAlign: 'right',
                    marginTop: 32,
                },
                items: [
                    {
                        text: '返回',
                        htmlType: 'button',
                        type: 'default',
                        route: 'goBack',
                        style: { marginLeft: 16, marginRight: 80 },
                    },
                ],
            },
            fields: [
                {
                    property: 'name',
                },
                {
                    property: 'sequence',
                    controlConfig: {
                        min: 0,
                        formatter: (value: number) => {
                            return parseInt(value.toString()) || 0;
                        },
                        parser: (value: number) => {
                            return parseInt(value.toString()) || 0;
                        },
                    },
                },
            ],
        },

        // 第三层（具体展示层）
        categoryEditBaseInfoForm: {
            component: 'ModifyForm',
            entity: 'categoryEditBaseInfo',
            labelCol: 8,
            loaderType: 'get',
            submit: {
                text: '保存',
            },
            submitSuccessBehavior: {
                route: 'goBack',
            },
            footer: {
                style: {
                    textAlign: 'right',
                    marginTop: 32,
                },
                items: [
                    {
                        text: '返回',
                        htmlType: 'button',
                        type: 'default',
                        route: 'goBack',
                        style: { marginLeft: 16, marginRight: 80 },
                    },
                ],
            },
            style: {
                width: '400px',
                marginTop: 32,
            },
            fields: [
                {
                    property: 'name',
                },
                {
                    property: 'imgType',
                    modifiable: false,
                },
                {
                    property: 'sequence',
                    controlConfig: {
                        min: 0,
                        formatter: (value: number) => {
                            return parseInt(value.toString()) || 0;
                        },
                        parser: (value: number) => {
                            return parseInt(value.toString()) || 0;
                        },
                    },
                },
                {
                    property: 'imgAppUrl',
                    width: 200,
                    rules: [{ required: false }],
                    controlConfig: {
                        maxCount: 1,
                        multiple: false,
                        fileName: 'fileName',
                        uploadUrl: `${ENV.API_ROOT}/images`,
                        mode: 'picture-card',
                    },
                    displayConfig: {
                        style: {
                            width: 50,
                        },
                    },
                },
            ],
        },

        CategoryUnionProductTableWrapper: {
            entities: [
                {
                    entityName: 'categoryUnionProduct',
                    name: 'categoryUnionProduct',
                },
            ],
            component: 'CategoryUnionProductTable',
        },
        CategoryFilterAttrTableWrapper: {
            entity: 'categoryFilterAttr',
            component: 'CategoryFilterAttrTable',
        },
    },
    routes: [
        {
            path: '/',
            childRoutes: [
                {
                    path: '/product',
                    childRoutes: [
                        {
                            path: '/category',
                            component: 'Viewport',
                            breadcrumbName: '展示分类管理',
                            childRoutes: [
                                {
                                    path: '/edit/:categoryId/:level',
                                    component: 'categoryEditView',
                                    breadcrumbName: '修改展示分类',
                                },
                                {
                                    path: '/editMenu/:categoryId/:level',
                                    component: 'categoryEditMenu',
                                    breadcrumbName: '编辑导航',
                                },
                                {
                                    path: '/addMenu/:parentId',
                                    component: 'categoryMenuView',
                                    breadcrumbName: '新增导航',
                                },
                                {
                                    path: '/addClass/:parentId',
                                    component: 'categoryClassificationAdd',
                                    breadcrumbName: '新增展示分类',
                                },
                                {
                                    path: '/add/:parentId',
                                    component: 'categoryAddView',
                                    breadcrumbName: '新增展示分类',
                                },
                                {
                                    path: '/',
                                    component: 'categoryMainView',
                                    breadcrumbName: '',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    ],
};
